<template>
    <div class="article-details" :class="{ top: top }">
        <el-container>
            <el-header :class="{ top: top }">
                <div class="details-header">
                    <div class="details-title" v-if="showTitle">
                        {{ articleContent.title }}
                    </div>
                    <bread-crumb v-else></bread-crumb>
                    <div
                        class="details-author"
                        v-if="articleContent.followid != 0"
                    >
                        <svg class="icon" aria-hidden="true" v-if="articleContent.role_no==4">
                            <use xlink:href="#iconzhuanjia" />
                        </svg>
                        <img :src="articleContent.avatar" alt srcset />
                        <div class="nickname">
                            {{ articleContent.username }}
                        </div>
                        <el-button
                            type="primary"
                            @click="setFollow"
                            round
                            :plain="!articleContent.isfollow"
                        >
                            <span
                                class="nomargin"
                                v-if="articleContent.isfollow == 1"
                                >取消</span
                            >关注
                        </el-button>
                    </div>
                </div>
            </el-header>
            <el-container id="main-container">
                <el-main id="main">
                    <div
                        class="article"
                        v-loading="loading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                    >
                        <div class="article-head">
                            <div class="head-option">
                                <div class="top star" @click="dialog = true">
                                    <i class="el-icon-share"></i>
                                </div>
                                <div class="top star" @click="star">
                                    <i
                                        class="el-icon-star-off"
                                        v-if="!collect"
                                    ></i>
                                    <i class="el-icon-star-on" v-else></i>
                                </div>
                            </div>
                            <div class="head-title">
                                <div class="title">
                                    {{ articleContent.title }}
                                </div>
                            </div>
                            <div class="article-tag">
                                <div>
                                    <span
                                        >来源：{{ articleContent.source }}</span
                                    >
                                </div>
                                <div>
                                    <i class="el-icon-time"></i>
                                    {{ articleContent.created }}
                                </div>
                                <div>
                                    发布人：{{ articleContent.release_user }}
                                </div>
                                <div class="view">
                                    浏览量：{{ articleContent.views }}
                                </div>
                            </div>
                            <div class="article-tag other">
                                <div
                                    v-for="(item,
                                    index) in articleContent.keyword"
                                    :key="index"
                                    class="other-item"
                                >
                                    {{ item }}
                                </div>
                            </div>
                        </div>
                        <div v-if="isbuy" class="article-buy-container">
                            <div
                                class="article-content"
                                v-html="articleContent.text"
                            ></div>
                            <div
                                class="article-pdf1"
                                v-if="articleContent.pdf && isScreen"
                            >
                                <div class="btn" @click="isScreen = false">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#icontuichuquanping" />
                                    </svg>
                                </div>
                                <iframe
                                    :src="articleContent.pdf"
                                    type="application/x-google-chrome-pdf"
                                    width="100%"
                                    height="100%"
                                ></iframe>
                            </div>
                            <div
                                class="article-pdf"
                                v-if="articleContent.pdf && !isScreen"
                            >
                                <!-- <div class="btn" @click="isScreen=true">
                                    <svg class="icon" aria-hidden="true">
                                        <use xlink:href="#iconquanping1" />
                                    </svg>
                                    <p>全屏查看</p>
                                </div>-->
                                <pdf :url="articleContent.pdf"></pdf>
                                <!-- <iframe
                                    :src="articleContent.pdf"
                                    type="application/x-google-chrome-pdf"
                                    width="832"
                                    height="840"

                                ></iframe>-->
                            </div>
                            <div
                                class="article-video"
                                v-if="articleContent.video"
                            >
                                <video
                                    class="myVideo"
                                    width="100%"
                                    height="100%"
                                    controls
                                    :src="articleContent.video"
                                >
                                    你的浏览器不支持视频播放
                                </video>
                            </div>
                            <div
                                class="article-redirect"
                                v-if="articleContent.redirect"
                            >
                                <el-link
                                    :href="articleContent.redirect"
                                    target="_blank"
                                    :underline="false"
                                    >{{ articleContent.redirect }}</el-link
                                >
                            </div>
                            <div v-if="articleContent.attachment">
                                <div class="similar-title">
                                    附件(点击下载)：
                                </div>
                                <div
                                    class="attachment"
                                    v-for="(item,
                                    index) in articleContent.attachment"
                                    :key="item.id"
                                >
                                    {{ index + 1 }}.
                                    <a
                                        :href="item.value"
                                        :download="item.title"
                                        target="_blank"
                                        >{{ item.title }}</a
                                    >
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div>
                                <div
                                    class="article-content"
                                    v-html="articleContent.description"
                                ></div>
                                <div
                                    class="buy-video"
                                    v-if="articleContent.type == 'video'"
                                >
                                    <img :src="articleContent.img" alt />
                                    <div class="buy-video-tip">
                                        <img
                                            :src="videoPlay | imageFmt()"
                                            alt
                                        />
                                    </div>
                                </div>
                                <div class="collect-fee">
                                    <p v-if="articleContent.type == 'video'">
                                        该视频为收费内容，如需观看或下载
                                    </p>
                                    <p v-else>试读已结束，如需继续阅读或下载</p>
                                    <div class="collect-btn">
                                        <el-button
                                            type="danger"
                                            round
                                            @click="needBuy('recharge')"
                                            >优惠充值</el-button
                                        >
                                        <el-button
                                            type="danger"
                                            round
                                            @click="needBuy('buy')"
                                            >单次下载</el-button
                                        >
                                        <el-button
                                            type="danger"
                                            round
                                            @click="needBuy('member')"
                                            >成为会员</el-button
                                        >
                                    </div>
                                </div>
                                <div class="insufficient" v-if="insufficient">
                                    您的余额不足，请立即充值
                                </div>
                            </div>
                        </div>
                        <div class="article-tag">
                            <div>撰稿时间：{{ articleContent.time }}</div>
                        </div>
                    </div>
                    <div class="comment-wrap" id="comment">
                        <div class="comment-user">
                            <div v-if="loginState" class="comment-login">
                                <img :src="userInfo.avatar" alt />
                                <div class="login-reply">
                                    <el-input
                                        type="textarea"
                                        placeholder="写下你的评论..."
                                        v-model="replyarea"
                                        maxlength="100"
                                        show-word-limit
                                    ></el-input>
                                    <el-button
                                        class="primary"
                                        type="primary"
                                        @click="toReply(replyarea, {})"
                                        >评论</el-button
                                    >
                                </div>
                            </div>
                            <div class="comment-nologin" v-else>
                                <el-button
                                    class="primary"
                                    type="primary"
                                    @click="toLogin"
                                    >登录</el-button
                                >
                                <span>后发表评论</span>
                            </div>
                        </div>
                        <div
                            class="comment-list"
                            v-loading="commentLoading"
                            element-loading-text="拼命加载中"
                            element-loading-spinner="el-icon-loading"
                        >
                            <div class="side-class">
                                <div class="side-class-title">
                                    <div class="side-class-btn">
                                        全部评论
                                        <span>{{ commentList.count }}</span>
                                    </div>
                                    <div class="more">
                                        <span
                                            :class="{ black: order == 'desc' }"
                                            @click="toOrder('desc')"
                                            >按时间倒序</span
                                        >
                                        <span
                                            :class="{ black: order == 'asc' }"
                                            @click="toOrder('asc')"
                                            >按时间正序</span
                                        >
                                    </div>
                                </div>
                            </div>
                            <el-collapse
                                accordion
                                id="collapse"
                                class="comment-all"
                                @change="replyFirstArea = ''"
                            >
                                <div
                                    class="comment-cell"
                                    v-for="(comment, index) in commentList.list"
                                    :key="index"
                                >
                                    <img
                                        :src="comment.avatar"
                                        :id="'top' + comment.id"
                                        alt
                                    />
                                    <div class="cell-left">
                                        <div class="left-top">
                                            <div class="name">
                                                {{ comment.nickname }}
                                            </div>
                                            <div class="content">
                                                {{ comment.content }}
                                            </div>
                                            <el-collapse-item>
                                                <template slot="title">
                                                    <div class="reply">
                                                        <span
                                                            >{{
                                                                comment.create
                                                                    | timeFmt()
                                                            }}前</span
                                                        >
                                                        <span class="reply-btn">
                                                            <i
                                                                class="el-icon-chat-line-square"
                                                            ></i>
                                                            回复
                                                        </span>
                                                    </div>
                                                </template>
                                                <div class="comment-reply">
                                                    <el-input
                                                        type="textarea"
                                                        :autosize="{
                                                            minRows: 1,
                                                            maxRows: 4
                                                        }"
                                                        :placeholder="
                                                            '回复' +
                                                                comment.nickname
                                                        "
                                                        v-model="replyFirstArea"
                                                    ></el-input>
                                                    <el-button
                                                        class="primary"
                                                        type="primary"
                                                        @click="
                                                            toReply(
                                                                replyFirstArea,
                                                                comment
                                                            )
                                                        "
                                                        >评论</el-button
                                                    >
                                                </div>
                                            </el-collapse-item>
                                        </div>
                                        <el-collapse
                                            accordion
                                            class="left-bottom"
                                            v-if="comment.sonlist.length"
                                            @change="replySecondArea = ''"
                                        >
                                            <div
                                                class="comment-cell"
                                                v-for="(item,
                                                index2) in comment.sonlist"
                                                :key="index2"
                                                v-if="index2 < 2 || showSon"
                                            >
                                                <img :src="item.avatar" alt />
                                                <div class="left-top second">
                                                    <div class="name">
                                                        {{ item.uname }}
                                                    </div>
                                                    <div class="name-content">
                                                        <div class="reply-name">
                                                            <span class="reply"
                                                                >回复</span
                                                            >
                                                            <span class="name"
                                                                >{{
                                                                    item.bname
                                                                }}：</span
                                                            >
                                                        </div>
                                                        <div class="content">
                                                            {{ item.content }}
                                                        </div>
                                                    </div>
                                                    <el-collapse-item>
                                                        <template slot="title">
                                                            <div class="reply">
                                                                <span
                                                                    >{{
                                                                        comment.create
                                                                            | timeFmt()
                                                                    }}前</span
                                                                >
                                                                <span
                                                                    class="reply-btn"
                                                                >
                                                                    <i
                                                                        class="el-icon-chat-line-square"
                                                                    ></i>
                                                                    回复
                                                                </span>
                                                            </div>
                                                        </template>
                                                        <div
                                                            class="comment-reply"
                                                        >
                                                            <el-input
                                                                type="textarea"
                                                                :autosize="{
                                                                    minRows: 1,
                                                                    maxRows: 4
                                                                }"
                                                                :placeholder="
                                                                    '回复' +
                                                                        item.uname
                                                                "
                                                                v-model="
                                                                    replySecondArea
                                                                "
                                                            ></el-input>
                                                            <el-button
                                                                class="primary"
                                                                type="primary"
                                                                @click="
                                                                    toReply(
                                                                        replySecondArea,
                                                                        item
                                                                    )
                                                                "
                                                                >评论</el-button
                                                            >
                                                        </div>
                                                    </el-collapse-item>
                                                </div>
                                            </div>
                                            <div
                                                class="havemore"
                                                v-if="
                                                    comment.sonlist.length >
                                                        2 && !showSon
                                                "
                                                @click="showSon = true"
                                            >
                                                更多{{
                                                    comment.sonlist.length - 2
                                                }}条回复
                                            </div>
                                            <div
                                                class="havemore"
                                                v-if="
                                                    comment.sonlist.length >
                                                        2 && showSon
                                                "
                                                @click="showSon = false"
                                            >
                                                收起
                                            </div>
                                        </el-collapse>
                                    </div>
                                </div>
                            </el-collapse>
                            <div
                                class="havemore"
                                v-if="
                                    commentList.count &&
                                        commentList.count >
                                            commentList.list.length
                                "
                                @click="getCommentList"
                            >
                                更多{{
                                    commentList.count - commentList.list.length
                                }}条评论
                            </div>
                            <div class="nomore" v-else>没有更多评论</div>
                        </div>
                    </div>
                </el-main>
                <el-aside style="width:280px;">
                    <detail-adv
                        :DetailAdv="advList.DetailInfo[0]"
                        v-if="advList.DetailInfo"
                    ></detail-adv>
                    <similar-article></similar-article>
                    <recommend-article></recommend-article>
                    <detail-adv
                        :DetailAdv="advList.DetailInfo[1]"
                        v-if="advList.DetailInfo"
                    ></detail-adv>
                    <detail-adv
                        :DetailAdv="advList.DetailInfo[2]"
                        v-if="advList.DetailInfo"
                    ></detail-adv>
                </el-aside>
            </el-container>
        </el-container>
        <el-dialog
            :visible.sync="buyDialog"
            width="35%"
            center
            :close-on-click-modal="false"
            :lock-scroll="true"
        >
            <span slot="title" class="dialog-title">{{
                articleContent.title
            }}</span>
            <div class="dialog-contianer">
                <div class="dialog-amount">
                    应付金额：
                    <span>{{ articleContent.amount }}</span>
                </div>
                <div class="dialog-btn" v-if="!insufficient">
                    <el-button type="primary" @click="payCreate(3)" round
                        >确定购买</el-button
                    >
                </div>
                <div class="dialog-btn" v-else>
                    <el-button round @click="payWx">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-wx-tx" />
                        </svg>
                        微信支付
                    </el-button>
                    <el-button round @click="payCreate(2)">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-zfbzf" />
                        </svg>
                        支付宝支付
                    </el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            :visible.sync="dialog"
            width="35%"
            center
            :close-on-click-modal="false"
            :lock-scroll="true"
        >
            <span slot="title" class="dialog-title">{{
                articleContent.title
            }}</span>
            <div class="dialog-contianer">
                <div class="dialog-btn">
                    <qr-code
                        :text="codeText"
                        :size="180"
                        error-level="L"
                    ></qr-code>
                </div>
                <div class="share-code">
                    <p class="inviteCode" id="inviteCode" v-text="codeText"></p>
                    <el-button
                        v-if="codeText"
                        class="copy"
                        @click="CopyUrl"
                        type="primary"
                        >复制链接</el-button
                    >
                </div>
                <div class="dialog-amount">手机扫描此二维码或复制链接分享</div>
            </div>
        </el-dialog>
        <login ref="login"></login>
        <BecomeMember ref="member"></BecomeMember>
    </div>
</template>

<script>
    import { baseUrl, baseUrlC } from '../../config';
    import DetailAdv from '../../components/common/DetailAdv';
    import Login from '../../components/common/Login';
    import SimilarArticle from '../../components/content/SimilarArticle';
    import RecommendArticle from '../../components/content/RecommendArticle';
    import BreadCrumb from '../../components/common/BreadCrumb.vue';
    import Pdf from '../../components/common/Pdf.vue';
    import BecomeMember from '../../components/common/BecomeMember';
    import { mapGetters } from 'vuex';

    export default {
        components: {
            DetailAdv,
            Login,
            SimilarArticle,
            RecommendArticle,
            BreadCrumb,
            Pdf,
            BecomeMember
        },
        data() {
            return {
                isScreen: false, // 是否全屏
                loading: true,
                isbuy: 1,
                advList: {},
                articleContent: {},
                buyDialog: false,
                articleCreate: {},
                videoPlay: 'video-play',
                commentList: {}, // 评论列表
                order: 'desc', // 评论排序
                page: 1, // 一级评论页数
                currentPage: 0, // pdf文件页码
                pageCount: 0, // pdf文件总页数
                pdfUrl: '',
                replyarea: '',
                replyFirstArea: '',
                replySecondArea: '',
                replyFirstShow: [],
                replySecondShow: {},
                commentLoading: false,
                showSon: false,
                way: 2,
                showTitle: false,
                top: false,
                collect: '', // 文章是否收藏
                dialog: false // 分享弹窗
            };
        },
        computed: {
            ...mapGetters(['userInfo', 'loginState']),
            insufficient() {
                return (
                    Number(this.userInfo.balance) <
                    Number(this.articleContent.amount)
                );
            },
            isIE() {
                if (!!window.ActiveXObject || 'ActiveXObject' in window) {
                    return true;
                } else {
                    return false;
                }
            },
            codeText() {
                return `${baseUrlC}/article-details?id=${this.$route.query.id}`;
                // return window.location.href
            }
        },
        mounted() {
            window.scrollTo(0, 0);
            window.addEventListener('scroll', this.handleScroll);
        },
        created() {
            this.refresh();
        },
        methods: {
            async refresh() {
                this.loading = true;
                this.commentLoading = true;
                this.articleContent = {};
                this.advList = {};
                this.commentList = {};
                this.pdfUrl = '';
                this.page = 1;
                this.replyarea = '';
                this.replyFirstArea = '';
                this.replySecondArea = '';
                await this.getArticleDetail();
                await this.getCommentList();
                this.getAdvList();
            },
            handleScroll() {
                // 获取滚动时的高度
                let scrollTop =
                    window.pageYOffset ||
                    document.documentElement.scrollTop ||
                    document.body.scrollTop;
                let clientHeight =
                    document.body.clientHeight ||
                    document.documentElement.clientHeight;
                //
                // console.log(scrollTop)
                if (scrollTop > clientHeight) {
                    // 滚动大于一屏的时候要做的操作
                    this.showTitle = true;
                } else {
                    this.showTitle = false;
                }
                if (scrollTop > 5) {
                    this.top = true;
                } else {
                    this.top = false;
                }
            },
            setFollow() {
                if (!this.loginState) {
                    this.$message({
                        type: 'error',
                        message: '您还没有登录，请先登录！'
                    });
                    return;
                }
                this.httpPost(this.$root.setUserFollow, {
                    followid: this.articleContent.followid,
                    status: this.articleContent.isfollow == 1 ? 2 : 1
                })
                    .then(result => {
                        this.refresh();
                    })
                    .catch(err => {
                        console.error('setFollow-err', err);
                    });
            },
            getAdvList() {
                this.httpGet(this.$root.getAdvList, {})
                    .then(result => {
                        this.advList = { ...result };
                    })
                    .catch(err => {
                        console.error('getAdvList-err', err);
                    });
            },
            async getArticleDetail() {
                this.articleContent = {};
                await this.httpGet(this.$root.getArticleDetail, {
                    article_id: this.$route.query.id
                })
                    .then(result => {
                        this.articleContent = result.data;
                        if (result.data.video) {
                            this.articleContent.video = result.data.video;
                        }
                        this.isbuy = Number(result.isbuy);
                        this.collect = Number(result.collect);
                        this.$nextTick(() => {
                            this.loading = false;
                        });
                    })
                    .catch(err => {
                        console.error('getArticleDetail-err', err);
                    });
            },
            toOrder(order) {
                this.page = 1;
                this.order = order;
                this.comment = {};
                this.commentLoading = true;
                this.getCommentList();
            },
            async getCommentList() {
                await this.httpGet(this.$root.getCommentList, {
                    aid: this.$route.query.id,
                    order: this.order, // desc倒叙 asc 正序 默认desc
                    page: this.page,
                    size: 99999,
                    spage: 1,
                    ssize: 99999
                })
                    .then(result => {
                        this.commentList.count = result.count;
                        // if (this.page == 1) {
                        this.commentList = { ...result };
                        // } else {
                        //     this.commentList.list = this.commentList.list.concat(
                        //         result.list
                        //     );
                        // }
                        // if (result.count > this.commentList.list.length) {
                        //     this.page++;
                        // }
                        this.commentLoading = false;
                        this.$nextTick(() => {
                            // 先计算文章的高度
                            setTimeout(() => {
                                if (this.$route.query.comment_id) {
                                    let id = this.$route.query.comment_id;
                                    var box = document.querySelector('#top' + id);
                                    console.log(box.offsetTop, 'top' + id);
                                    window.scrollTo({
                                        top: box.offsetTop,
                                        behavior: 'smooth'
                                    });
                                }
                            }, 500);
                        });
                    })
                    .catch(err => {
                        console.error('getCommentList-err', err);
                        this.commentLoading = false;
                    });
            },
            toLogin() {
                this.$refs.login.toLog();
            },

            toReply(replyarea, reply) {
                if (!this.loginState) {
                    this.$message({
                        type: 'error',
                        message: '您还没有登录，请先登录！'
                    });
                    this.toLogin();
                    return;
                }
                if (replyarea == '') {
                    this.$message({
                        type: 'warning',
                        message: '请先填写评论内容！'
                    });
                    return;
                }
                this.httpPost(this.$root.setComment, {
                    aid: this.$route.query.id,
                    content: replyarea,
                    topid: reply.id ? reply.id : 0,
                    buid: reply.uid ? reply.uid : 0
                })
                    .then(result => {
                        this.$message({
                            type: 'success',
                            message: '评论成功！'
                        });
                        this.refresh();
                    })
                    .catch(err => {
                        this.$message({
                            type: 'error',
                            message: '评论失败，请刷新后重新尝试'
                        });
                        console.error('setComment-err', err);
                    });
            },
            needBuy(type) {
                if (type == 'member') {
                    this.$refs.member.show();
                    return;
                }
                if (!this.loginState) {
                    this.$message({
                        type: 'error',
                        message: '您还没有登录，请先登录！'
                    });
                    this.toLogin();
                    return;
                }
                if (type == 'recharge') {
                    this.$router.push({
                        name: 'recharge'
                    });
                }

                if (type == 'buy') {
                    this.buyDialog = true;
                }
            },
            articleSure() {
                this.httpPost(this.$root.setBuySure, {
                    id: this.articleCreate.id
                })
                    .then(res => {
                        this.$message({
                            message: '购买成功！',
                            type: 'success'
                        });
                        this.buyDialog = false;
                        this.refresh();
                    })
                    .catch(err => {
                        this.buyDialog = false;
                        console.error('setBuySure-err', err);
                    });
            },
            payCreate(way) {
                this.way = way; // 2支付宝3余额
                this.httpPost(this.$root.payCreate, {
                    way: this.way,
                    target_id: this.$route.query.id,
                    target_type: 1
                })
                    .then(result => {
                        if (this.way == 2) {
                            let token = this.$store.state.login.token;
                            location.href =
                                baseUrl +
                                '/pay/confirm?pay_id=' +
                                result.id +
                                '&token=' +
                                token;
                        } else if (this.way == 3) {
                            this.payConfirm(result.id);
                        }
                    })
                    .catch(err => {
                        this.buyDialog = false;
                        this.$message({
                            message: '操作失败，请刷新重试',
                            type: 'error'
                        });
                        console.error('payCreate-err', err);
                    });
            },
            payConfirm(id) {
                this.httpGet(this.$root.payConfirm, {
                    pay_id: id
                })
                    .then(result => {
                        this.$message({
                            message: '购买成功！',
                            type: 'success'
                        });
                        this.buyDialog = false;
                        this.refresh();
                    })
                    .catch(err => {
                        this.buyDialog = false;
                        this.$message({
                            message: '操作失败，请刷新重试',
                            type: 'error'
                        });
                        console.error('payConfirm-err', err);
                    });
            },
            payWx() {
                // this.way = 1;
                this.$message('暂未开通微信支付');
            },
            star() {
                if (!this.$store.state.login.token) {
                    this.$message({
                        type: 'error',
                        message: '您还没有登录，请先登录！'
                    });
                    return;
                }
                this.changeCollection();
            },
            changeCollection() {
                if (!this.collect) {
                    this.httpPost(this.$root.setCollection, {
                        id: this.$route.query.id
                    })
                        .then(result => {
                            this.$message({
                                message: '收藏成功！',
                                type: 'success'
                            });
                            this.collect = 1;
                        })
                        .catch(err => {
                            console.error('setCollection-err', err);
                        });
                } else {
                    this.httpPost(this.$root.cancelCollection, {
                        id: this.$route.query.id
                    })
                        .then(result => {
                            this.$message({
                                message: '取消成功！',
                                type: 'success'
                            });
                            this.collect = 0;
                        })
                        .catch(err => {
                            console.error('cancelCollection-err', err);
                        });
                }
            },
            CopyUrl(data) {
                var Url2 = document.getElementById('inviteCode').innerText;
                var oInput = document.createElement('input');
                oInput.value = Url2;
                document.body.appendChild(oInput);
                oInput.select(); // 选择对象
                document.execCommand('Copy'); // 执行浏览器复制命令
                oInput.className = 'oInput';
                oInput.style.display = 'none';
                this.$message({
                    message: '复制成功!',
                    type: 'success'
                });
            }
        },
        watch: {
            '$route.query.id': function(newValue, oldValue) {
                console.log('newValue, oldValue', newValue, oldValue);
                if (!this.loading && this.$route.name == 'article-details') {
                    this.refresh();
                }
            },
            articleContent: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    console.log(
                        'articleContent-45555555555-newValue, oldValue',
                        newValue,
                        oldValue
                    );
                    // if (newValue.video) {
                    this.articleContent.video = newValue.video;
                    // }
                }
            }
        },
        destroyed() {
            document.removeEventListener('scroll', this.handleScroll);
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';
    @import '~assets/css/wang.css';

    .el-header {
        width: 100%;
        background: white;
        height: 54px !important;
        box-shadow: 0px 2px 8px 0px rgba(31, 46, 77, 0.1);
        position: fixed;
        top: 274px;
        padding: 0;
        z-index: 2;

        &.top {
            position: fixed;
            top: 0;
        }
    }

    .details-header {
        width: 1180px;
        height: 100%;
        margin: auto;
        flex-x(space-between, center);
    }

    .details-title {
        height: 33px;
        font-size: 24px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 33px;
    }

    .details-author {
        flex-x(flex-start, center);
        position: relative;

        .icon {
            width: 20px;
            height: 20px;
            fill: #f0c328;
            position: absolute;
            left: 25px;
            top: -6px;
            transform: rotate(20deg);
            -ms-transform: rotate(20deg); /* IE 9 */
            -moz-transform: rotate(20deg); /* Firefox */
            -webkit-transform: rotate(20deg); /* Safari 和 Chrome */
            -o-transform: rotate(20deg); /* Opera */
        }

        img {
            width: 40px;
            height: 40px;
            border-radius: 20px;
        }

        .nickname {
            height: 22px;
            font-size: 16px;
            font-weight: 500;
            color: rgba(0, 0, 0, 1);
            line-height: 22px;
            margin: 0 16px 0 8px;
        }

        .nomargin {
            margin-right: 0;
        }

        .el-button {
            width: 72px;
            height: 32px;
            line-height: 32px;
            border-radius: 20px;
            padding: 0;
        }

        .el-button:hover {
            width: 72px;
            height: 32px;
            padding: 0;
        }
    }

    .el-aside {
        width: 100%;
        margin-top: -18px;
    }

    .el-main {
        padding: 0 !important;
        z-index: 0;
    }

    #main-container {
        position: relative;
    }

    .article-details {
        margin-top: 70px;
        min-height: 540px;
        position: relative;
        font-family: "SimSun";

        &.top {
            margin-top: 18px;
        }
    }

    .article {
        width: 832px;
        background: white;
        padding: 24px;
        min-height: 580px;
    }

    .article-head {
        border-bottom: 1px solid grayE8;
        min-height: 74px;
        font-size: 16px;
        color: gray3;
        line-height: 21px;
    }

    .head-option {
        flex-x(flex-end);
        color: gray6;
        font-size: 25px;

        .top {
            // width: 48px;
            // height: 48px;
            // flex-center();
            // box-shadow: 0px 2px 4px 0px rgba(204, 204, 204, 0.5);
            border-radius: 4px;
            background: #d9d9d9;
        }

        .star {
            background: white;
            margin-bottom: 8px;
            color: #5b5b5b;
            border: 1px #d9d9d9 dashed;
            padding: 5px;
        }

        .el-icon-star-on {
            color: blue;
        }

        div:hover {
            cursor: pointer;
        }

        div {
            margin-right: 10px;
        }
    }

    .head-title {
        flex-center();
        margin-top: 10px;
        text-align: center;
    }

    .title {
        width: 90%;
        font-size: 36px;
        color: gray3;
        line-height: 47px;
    }

    .article-tag {
        width: 100%;
        flex-x(space-between);
        font-size: 12px;
        color: gray9;
        line-height: 26px;
        margin-top: 10px;
        flex-wrap: wrap;

        div {
            margin-right: 20px;
        }

        .view {
            display: flex;
            justify-content: flex-end;
        }

        &.other {
            flex-x(flex-start);
            width: 100%;
            flex-wrap: wrap;

            .other-item {
                margin-right: 20px;
            }
        }
    }

    .article-content >>> img {
        width: 96%;
    }

    .article-content {
        // max-width: 702px;
        font-size: 14px;
        color: gray3;
        line-height: 28px;
        text-indent: 2em;
        margin: auto;
        margin-top: 30px;
        box-sizing: border-box;
        overflow: hidden;
    }

    .article-pdf {
        min-height: 840px;
        height: 100%;
        // height: 840px;
        // overflow-y scroll
        margin-bottom: 50px;
        position: relative;

        .btn {
            width: 100%;
            text-align: right;
            margin-bottom: 10px;
            cursor: pointer;
            flex-x(flex-end);

            .icon {
                width: 20px;
                height: 20px;
                fill: blue;
                margin-right: 10px;
            }

            p {
                color: blue;
            }
        }

        .arrow {
            text-align: right;

            span {
                margin: 0 20px;
            }

            span:hover {
                cursor: pointer;
                color: blue;
            }
        }
    }

    .article-pdf1 {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999999;

        .btn {
            text-align: right;
            color: blue;
            cursor: pointer;
            position: absolute;
            top: 60px;
            right: 54px;
            flex-x(center, center);
            background: #f6f6f6;
            width: 40px;
            height: 40px;
            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            border-radius: 50%;
            box-shadow: 0 2px 2px gray9;

            .icon {
                width: 16px;
                height: 16px;
                fill: gray6;
            }
        }
    }

    .article-video {
        margin: 30 0px;
        width: 832px;
        height: 480px;
    }

    .article-redirect {
        margin: 20px;
        text-align: center;
        color: blue;
        line-height: 22px;

        >>>.el-link {
            color: blue;
            flex-x();
            flex-wrap: wrap;
        }
    }

    >>> .ql-container.ql-snow {
        border: 0px solid #ccc !important;
    }

    .similar {
        border-top: 1px solid grayE8;
        padding: 25px 16px;
        margin-top: 150px;
    }

    .similar-title {
        font-size: 14px;
        color: gray3;
        line-height: 19px;
    }

    .text {
        flex-x(space-between);
        margin-top: 10px;
        font-size: 14px;
        color: gray6;
        line-height: 22px;
    }

    .text:hover {
        color: blue;
        cursor: pointer;

        p {
            color: blue;
        }

        .cell-icon {
            background: blue;
        }
    }

    .cell-text {
        flex-x(flex-start);
        max-width: 85%;

        p {
            width: 100%;
            ellipsis();
        }
    }

    .cell-icon {
        width: 6px;
        height: 6px;
        background: grayE8;
        margin-right: 8px;
    }

    .blue-tip {
        margin: 20px 0;
        font-size: 14px;
        color: blue;
        line-height: 19px;
    }

    .buy-video {
        margin-top: 20px;
        position: relative;

        img {
            width: 832px;
            height: 480px;
        }

        .buy-video-tip {
            width: 832px;
            height: 480px;
            position: absolute;
            top: 0;
            left: 0;
            flex-center();

            img {
                width: 157px;
                height: 111px;
                opacity: 0.7;
            }
        }

        .blue-tip {
            margin: 20px 0;
            font-size: 14px;
            color: yellow;
            line-height: 19px;
        }
    }

    >>>.el-dialog__header {
        flex-x(space-between);

        .dialog-title {
            font-size: 16px;
            color: gray3;
            line-height: 21px;
            text-align: left;
            width: 90%;
            ellipsis();
        }
    }

    .dialog-contianer {
        padding: 24px;
        flex-y();

        .dialog-amount {
            font-size: 20px;
            color: rgba(0, 0, 0, 0.85);
            line-height: 22px;
            margin-top: 20px;
            font-weight: 500;

            span {
                color: rgba(255, 87, 31, 1);
            }
        }

        .dialog-btn {
            flex-x();
            margin: 40px 0;

            svg {
                width: 16px;
                height: 16px;
                margin-right: 12px;
            }
        }
    }

    .insufficient {
        font-size: 14px;
        color: red;
        line-height: 19px;
        margin-top: 20px;
    }

    .primary {
        margin-top: 16px;
        width: 100px;
        height: 36px;
    }

    .video-container {
        flex-x();
        width: 100%;
        flex-wrap: wrap;
    }

    .single-video {
        padding: 16px 0;
        // height: 10%;
        width: 30%;
        margin: 10px 0;
    }

    .attachment {
        // margin-left: 2em;
        font-size: 14px;
        color: blue;
        margin-top: 5px;

        a {
            margin-top: 10px;
            font-size: 14px;
            line-height: 25px;
            color: blue;
        }
    }

    .collect-fee {
        width: 832px;
        height: 158px;
        background: rgba(240, 240, 240, 1);
        margin: auto;
        margin-top: 35px;
        flex-y();

        .collect-btn {
            flex-x();
            margin-top: 15px;
        }
    }

    .comment-wrap {
        width: 832px;
        background: white;
        min-height: 300px;
        margin-top: 15px;
        padding: 24px;

        .comment-user {
            .comment-login {
                width: 100%;
                flex-x(space-between, flex-start);

                .login-reply {
                    flex-y(space-between, flex-end);
                    width: 774px;
                }

                img {
                    width: 40px;
                    height: 40px;
                    border-radius: 45px;
                }

                >>>.el-textarea {
                    width: 100%;
                    height: 80px;
                }

                >>>textarea {
                    width: 100%;
                    height: 80px;
                    background: rgba(250, 250, 250, 1);
                    border-radius: 4px;
                    border: 1px solid rgba(244, 244, 244, 1);
                }
            }

            .comment-nologin {
                width: 832px;
                height: 80px;
                background: rgba(250, 250, 250, 1);
                border-radius: 4px;
                border: 1px solid rgba(244, 244, 244, 1);
                margin: auto;
                flex-x(center, center);
                font-size: 14px;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.65);
                line-height: 45px;

                span {
                    margin-left: 16px;
                    height: 67px;
                    line-height: 80px;
                }
            }
        }
    }

    >>>.el-collapse-item__header {
        i {
            font-size: 0;
            color: #F4F4F4;
        }
    }

    .comment-list {
        .side-class-title {
            padding: unset;
            border-bottom: 0px;
            height: 40px;
        }

        .comment-all {
            width: 100%;

            .comment-cell {
                flex-x(flex-start, flex-start);
                padding: 16px 0;
                border-bottom: 1px solid #E8E8E8;

                .cell-left {
                    width: 780px;
                }

                .second {
                    width: 682px;
                }

                .comment-reply {
                    width: 100%;
                    flex-y(center, flex-end);
                    margin-top: 10px;

                    >>>textarea {
                        width: 100%;
                        min-height: 48px;
                        background: rgba(255, 255, 255, 1);
                        border-radius: 4px;
                        border: 1px solid rgba(115, 176, 255, 1);
                    }

                    .el-button {
                        width: 100px;
                        height: 36px;
                    }
                }

                .reply-btn:hover {
                    cursor: pointer;
                    color: blue;

                    i {
                        cursor: pointer;
                        color: blue;
                    }
                }

                .left-bottom {
                    background: #F4F4F4;
                    padding: 24px;
                    width: 732px;
                    margin-top: 12px;

                    >>>.el-collapse-item__header {
                        background: #F4F4F4;
                        border-bottom: 0px;

                        i {
                            font-size: 0;
                            color: #F4F4F4;
                        }
                    }

                    >>>.el-collapse-item__wrap {
                        background: #F4F4F4;
                        border-bottom: 0px;
                    }

                    >>>.el-collapse-item__content {
                        background: #F4F4F4;
                        padding-bottom: 0;
                    }
                }

                .name-content {
                    width: 100%;
                    flex-x(flex-start, flex-start);

                    .reply-name {
                        max-width: 25%;
                        flex-wrap: wrap;
                        margin-top: 12px;

                        span {
                            margin-right: 12px;
                        }
                    }

                    .content {
                        width: 75%;
                        flex-wrap: wrap;
                    }
                }

                img {
                    width: 40px;
                    height: 40px;
                    border-radius: 45px;
                    margin-right: 10px;
                }

                .name {
                    width: 100%;
                    height: 22px;
                    font-size: 14px;
                    font-weight: 500;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 22px;
                    ellipsis();
                }

                .content {
                    width: 100%;
                    min-height: 22px;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 22px;
                    flex-wrap: wrap;
                    margin: 12px 0;
                }

                .reply {
                    width: 100%;
                    height: 22px;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.45);
                    line-height: 22px;

                    span {
                        margin-right: 12px;
                    }

                    i {
                        font-size: 14px;
                        color: rgba(0, 0, 0, 0.45);
                        margin-right: 8px;
                    }
                }
            }
        }

        .more {
            font-size: 12px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.25);
            line-height: 22px;

            span {
                margin-right: 20px;
            }

            .black {
                color: black;
            }
        }

        .nomore {
            width: 100%;
            height: 71px;
            flex-center();
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.25);
            line-height: 22px;
        }

        .havemore {
            width: 100%;
            height: 40px;
            flex-center();
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            line-height: 22px;
            cursor: pointer;
        }
    }

    >>>.el-icon-chat-line-square {
        font-size: 14px !important;
        color: rgba(0, 0, 0, 0.45) !important;
        margin-right: 5px;
    }
</style>
